import { render, staticRenderFns } from "./EditCourseFAQ.vue?vue&type=template&id=262ec832&scoped=true&"
import script from "./EditCourseFAQ.vue?vue&type=script&lang=js&"
export * from "./EditCourseFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262ec832",
  null
  
)

export default component.exports